import { Model, HasOne } from 'spraypaint';
import ApplicationRecord from '../../ApplicationRecord';
import type AuditsExport from '../AuditsExport';

@Model()
class AuditsExportsCadrageDendreoExport extends ApplicationRecord {
  static jsonapiType = 'audits-exports-cadrage_dendreo_exports' as const;

  // Relationships
  @HasOne('audits-exports') export!: AuditsExport;
}

export default AuditsExportsCadrageDendreoExport;
